/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MoveBookingViaLinkPayload = {
    ruleId: number;
    start: string;
    selectedLocation: MoveBookingViaLinkPayload.selectedLocation;
    message?: string;
};
export namespace MoveBookingViaLinkPayload {
    export enum selectedLocation {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

